/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import { isEmpty, assign } from 'lodash';

export const WebLink = (path) => new URL(path);

const includeId = (baseLink) =>
  !baseLink.pathname.includes('transactions/automatic') && !baseLink.pathname.includes('checkout/transfer');
export const withUid = (webLink, uid) =>
  webLink.searchParams.append('uid', uid);
export const withSelectedAgreementId = (webLink, id) =>
  webLink.searchParams.append('selectedAgreementIDs', id);

export const webLinkBuilder = (path, id) => {
  if (isEmpty(path)) {
    return '';
  }

  const baseLink = WebLink(path);
  const productType =
    baseLink.searchParams.get('productTypeCategory') ||
    baseLink.searchParams.get('productTypeCategory');
  productType === 'ManagedAccount' &&
    baseLink.pathname.includes('automatic') &&
    baseLink.searchParams.delete('productTypeCategory');

  if (includeId(baseLink)) {
    productType === 'ManagedAccount' && !baseLink.pathname.includes('automatic')
      ? withUid(baseLink, id)
      : withSelectedAgreementId(baseLink, id);
  }

  return baseLink;
};

export const presentationLink = (
  webLink = null,
  label = '',
  target = '',
  external = false
) => {
  let linkData = {};

  const validWebLink = webLink && typeof webLink === 'object';
  if (!validWebLink) {
    throw new Error('type error need URL object');
  }
  linkData = assign(linkData, { link: webLink });

  if (label) {
    linkData = assign(linkData, { label });
  }

  if (target) {
    linkData = assign(linkData, { target });
  }

  if (external || validWebLink) {
    const isExternal = external ? external : webLink.href.indexOf('http') > 0;

    linkData = assign(linkData, { external: isExternal });
  }

  return linkData;
};
